import "./features.scss";
import "../../src-utilities/header";
import "../../src-utilities/footer";
import Swiper from "./../../../node_modules/swiper";
import { Navigation, Autoplay, Keyboard, Pagination } from "swiper/modules";
import JustValidate from "just-validate";

const showMoreBtn = document.getElementById("show-more-btn");
const planboxes = document.querySelectorAll(".plan-box");

let GoogleSendURL =
    "https://script.google.com/macros/s/AKfycbyML8OHUDSwwvY_QcBlZ2uHYN_rQIx_VlWZPLjpxoJ9dB8GQEr6J7U0D8kNzC3-p0nH/exec";

let loader = document.querySelector(".loader");

let height = "150px";
if (window.innerWidth < 600) {
    height = "260px";
}

if (showMoreBtn) {
    showMoreBtn.addEventListener("click", (e) => {
        const planId = e.currentTarget.getAttribute("data-plan");
        const matched = Array.from(planboxes).find(
            (box) => box.getAttribute("data-plan-box-id") === planId,
        );
        if (!matched) return;

        const isActive = matched.classList.contains("active");

        planboxes.forEach((box) => {
            if (box !== matched) {
                box.classList.remove("active");
            }
        });

        if (isActive) {
            matched.style.height = matched.scrollHeight + "px";
            requestAnimationFrame(() => {
                matched.style.height = height;
                matched.classList.remove("active");
            });
        } else {
            matched.classList.add("active");
            const fullHeight = matched.scrollHeight + "px";
            matched.style.height = height;
            requestAnimationFrame(() => {
                matched.style.height = fullHeight;
            });

            matched.addEventListener(
                "transitionend",
                () => {
                    if (matched.classList.contains("active")) {
                        matched.style.height = "fit-content";
                    }
                },
                { once: true },
            );
        }
    });
}

let swiperOptions = {
    modules: [Autoplay],
    slidesPerView: "auto",
    spaceBetween: 50,
    speed: 5000,
    freeMode: true,
    freeModeMomentum: false,
    autoplay: {
        delay: 0,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
    },
    loop: true,
    breakpoints: {
        0: {
            slidesPerView: 3,
            spaceBetween: 15,
        },
        600: {
            slidesPerView: 5,
            spaceBetween: 50,
        },
        1024: {
            slidesPerView: 6,
            spaceBetween: 50,
        },
    },
};

new Swiper(".customers-logo", swiperOptions);

// iframe tumbnail
let iframeSection = document.querySelector(".iframe");
let ytFalse = document.querySelector(".yt-false");
let ytImg = document.querySelector(".yt-img");
let ytLink =
    "https://www.youtube.com/embed/eGT8_QfW8UE?si=SIt93Rugj6KHx2K-?autoplay=1&modestbranding=1&rel=0&showinfo=0";

if (ytLink && ytImg) {
    let youtubeMatch = ytLink.match(/youtube\.com.*(\?v=|\/embed\/)(.{11})/);
    if (youtubeMatch) {
        let youtube_video_id = youtubeMatch.pop();
        if (youtube_video_id && youtube_video_id.length == 11) {
            let video_thumbnail =
                "//img.youtube.com/vi/" + youtube_video_id + "/maxresdefault.jpg";
            ytImg.src = video_thumbnail;
        }
    }
}

if (ytFalse && iframeSection) {
    ytFalse.addEventListener("click", function () {
        iframeSection.innerHTML =
            `<iframe loading="lazy" class="yt-autoplay" src="` +
            ytLink +
            `" title="YouTube video player"  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>`;
        let ytVideo = document.querySelector(".yt-autoplay");
        if (ytVideo) {
            if (ytLink.indexOf("?") != -1) {
                ytVideo.src = ytLink + "&autoplay=1";
            } else {
                ytVideo.src = ytLink + "?autoplay=1";
            }
            console.log("true");
        } else {
            console.error("iframe not found .");
        }
    });
}

// What Makes ChargeOn Different Accordion Script ------------------------------
const initChargeonDifferentAccordion = () => {
    const accordionBoxes = document.querySelectorAll(
        ".chargeon-different-section .accordion-box",
    );
    const mainImg = document.getElementById("chargeon-different-main-img");

    if (!accordionBoxes.length) return;

    accordionBoxes.forEach((box) => {
        const desc = box.querySelector(".accordion-description");

        if (box.classList.contains("active") && desc) {
            desc.style.maxHeight = desc.scrollHeight + "px";
        }

        box.addEventListener("click", (e) => {
            if (e.target.closest(".accordion-description")) {
                return;
            }

            const isActive = box.classList.contains("active");

            accordionBoxes.forEach((otherBox) => {
                if (otherBox !== box) {
                    otherBox.classList.remove("active");
                    const otherDesc = otherBox.querySelector(".accordion-description");
                    if (otherDesc) {
                        otherDesc.style.maxHeight = null;
                    }
                }
            });

            if (isActive) {
                box.classList.remove("active");
                if (desc) {
                    desc.style.maxHeight = null;
                }
            } else {
                box.classList.add("active");
                if (desc) {
                    desc.style.maxHeight = desc.scrollHeight + "px";
                }

                // Dynamic media switching support (Image)
                const mediaUrl = box.getAttribute("data-image");
                if (mediaUrl && mainImg) {
                    mainImg.style.opacity = "0.4";

                    setTimeout(() => {
                        mainImg.src = mediaUrl;
                        mainImg.style.opacity = "1";
                    }, 150);
                }
            }
        });
    });
};
initChargeonDifferentAccordion();
// What Makes ChargeOn Different Accordion Script ------------------------------

const swiper = new Swiper(".testimonialSwiper", {
    modules: [Navigation, Autoplay, Keyboard, Pagination],
    slidesPerView: 1,
    spaceBetween: 30,
    loop: true,
    autoplay: {
        delay: 5000,
        disableOnInteraction: false,
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    speed: 600,
    effect: "slide",
});

// const contactUsForm = document.getElementById("contact-us-form");
// const contactUsFormData = new JustValidate(contactUsForm);

// contactUsFormData
//   .addField("#contact-firstname", [
//     {
//       rule: "required",
//     },
//     {
//       rule: "minLength",
//       value: 2,
//     },
//     {
//       rule: "customRegexp",
//       value: /^(?=\S)([A-Za-z.]+(?:\s+[.A-Za-z]+){1,})$/,
//       errorMessage: "Enter Valid Full Name",
//     },
//   ])
//   .addField("#contact-company", [
//     {
//       rule: "required",
//     },
//     {
//       rule: "minLength",
//       value: 2,
//     },
//   ])
//   .addField("#contact-email", [
//     {
//       rule: "required",
//     },
//     {
//       rule: "email",
//     },
//     {
//       validator: (value) => {
//         let emailRegex =
//           /^[a-zA-Z0-9](?:[a-zA-Z0-9._-]*[a-zA-Z0-9])?@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,7})+$/;
//         return emailRegex.test(value);
//       },
//       errorMessage: "Please Enter Valid Email Address",
//     },
//   ])
//   .addField("#chargeOnPhoneCode", [
//     {
//       rule: "custom",
//       validator: (value) => value !== "Code",
//       errorMessage: "The field is required",
//     },
//   ])
//   .addField("#phoneCountryCode", [
//     {
//       rule: "required",
//     },
//     {
//       rule: "minLength",
//       value: 4,
//     },
//     {
//       rule: "customRegexp",
//       value: /^[0-9]+$/,
//     },
//     {
//       rule: "maxLength",
//       value: 15,
//     },
//     {
//       rule: "number",
//     },
//   ]);

// contactUsForm.addEventListener("submit", async (event) => {
//   event.preventDefault();
//   if (contactUsFormData.isValid == false) {
//     return false;
//   }
//   loader.classList.add("active");

//   let formData = new FormData(event.target);
//   let fullName = formData.get("lfirstname").split(" ");
//   let firstName, lastName;
//   [firstName, ...lastName] = fullName;
//   lastName = lastName.join(" ");
//   formData.set("lfirstname", firstName);
//   formData.set("llastname", lastName);
//   formData.append("sendurlvalue", window.location.href);
//   formData.append("lsource", "ChargeOn - Interested");

//   const myHeaders = new Headers();
//   myHeaders.append("Content-Type", "application/json");

//   // Initiate the Sales IQ visitor data
//   if (window.$zoho && window.$zoho.salesiq) {
//     try {
//       $zoho.salesiq.visitor.uniqueid();
//       $zoho.salesiq.visitor.name(firstName + " " + lastName);
//       $zoho.salesiq.visitor.email(formData.get("lemail"));
//       console.log("SalesIQ Name/Email set");
//     } catch (error) {
//       console.warn("SalesIQ Error:", error);
//     }
//   }

//   const raw = JSON.stringify({
//     firstName: formData.get("lfirstname"),
//     lastName: formData.get("llastname"),
//     email: formData.get("lemail"),
//     company: formData.get("lcompany"),
//     phone:
//       formData.get("chargeOnPhoneCode") + " " + formData.get("phoneNumber"),
//     leadSource: formData.get("lsource"),
//     websiteVisitURL: window.location.href,
//   });

//   const requestOptions = {
//     method: "POST",
//     headers: myHeaders,
//     body: raw,
//     redirect: "follow",
//   };
//   const googleRequestOptions = {
//     method: "GET",
//     redirect: "follow",
//   };
//   let request = "?";
//   [...formData].forEach(([key, value], index) => {
//     request += `${index === 0 ? "" : "&"}${key + "=" + value}`;
//   });

//   // Request 1: Main Backend
//   const backendRequest = fetch(
//     "https://us-west1-zoho-crm-scripts.cloudfunctions.net/queueLeadHttp",
//     requestOptions,
//   );

//   // Request 2: Update the Google Sheet Data
//   const googleRequest = fetch(GoogleSendURL + request, googleRequestOptions);

//   // Waiting until these request get's completed
//   try {
//     await Promise.allSettled([backendRequest, googleRequest]);
//   } catch (e) {
//     console.error("API Error", e);
//   }

//   // Redirect
//   window.location.href = "https://products.cyntexa.com/success/";
// });

const BindEvent = () => {
    let faq_question = document.getElementsByClassName("faq-question");
    let hiddenFaqs = document.querySelectorAll(".hidden-faq");
    let viewAllFaqBtn = document.querySelector(".faq-view-btn");

    for (let i = 0; i < faq_question.length; i++) {
        const question = faq_question[i];
        question.addEventListener("click", function (e) {
            let all_faq = document.getElementsByClassName("faq");
            let isopen = e.currentTarget.parentNode.classList.contains("active");
            for (let index = 0; index < all_faq.length; index++) {
                all_faq[index].classList.remove("active");
            }
            if (isopen == false) {
                e.currentTarget.parentNode.classList.add("active");
            }
        });
    }

    if (viewAllFaqBtn) {
        viewAllFaqBtn.addEventListener("click", () => {
            if (!viewAllFaqBtn.classList.contains("active")) {
                viewAllFaqBtn.textContent = "View Less";
                viewAllFaqBtn.classList.add("active");
                hiddenFaqs.forEach((hiddenFaq) => {
                    hiddenFaq.style.display = "flex";
                });
            } else {
                viewAllFaqBtn.textContent = "View All";
                viewAllFaqBtn.classList.remove("active");
                hiddenFaqs.forEach((hiddenFaq) => {
                    hiddenFaq.style.display = "none";
                });
            }
        });
    }
};
BindEvent();

// Everything You Need - Nested Swipers Initialization
const initFeatureEverythingNeed = () => {
    // Main Top Nav Swiper
    const mainNavSwiper = new Swiper(".feature-main-nav.swiper", {
        modules: [Navigation],
        navigation: {
            nextEl: ".nav-next",
            prevEl: ".nav-prev",
        },
        slidesPerView: "auto",
        spaceBetween: 10,
        freeMode: true,
        watchSlidesProgress: true,
    });

    // Main Content Screens Swiper
    const mainContentSwiper = new Swiper(".feature-content-screens.swiper", {
        slidesPerView: 1,
        spaceBetween: 35,
        effect: "slide",
        autoHeight: true,
        on: {
            slideChange: function () {
                const activeIndex = this.activeIndex;
                const navItems = document.querySelectorAll(".feature-nav-item");
                navItems.forEach((nav) => nav.classList.remove("active"));
                
                if (navItems[activeIndex]) {
                    navItems[activeIndex].classList.add("active");
                    // Scroll the nav swiper to the active item to fix navigation on mobile
                    if (mainNavSwiper) {
                        mainNavSwiper.slideTo(activeIndex);
                    }
                }
            },
        },
    });

    // Click on nav item to change main content slide
    const navItems = document.querySelectorAll(".feature-nav-item");
    navItems.forEach((item, index) => {
        item.addEventListener("click", () => {
            mainContentSwiper.slideTo(index);
            navItems.forEach((nav) => nav.classList.remove("active"));
            item.classList.add("active");
            if (mainNavSwiper) {
                mainNavSwiper.slideTo(index);
            }
        });
    });

    // Inner Swipers (one per main slide)
    const innerSwipers = document.querySelectorAll(".inner-swiper");
    innerSwipers.forEach((innerElement) => {
        new Swiper(innerElement, {
            modules: [Autoplay, Pagination],
            slidesPerView: 1,
            spaceBetween: 30,
            effect: "slide",
            autoHeight: true,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
            },
            pagination: {
                el: innerElement.parentElement.querySelector(".inner-swiper-pagination"),
                clickable: true,
                renderBullet: function (index, className) {
                    // Get the title from the slide's data attribute
                    const slides = innerElement.querySelectorAll(".swiper-slide.inner-slide");
                    const title = slides[index] ? slides[index].getAttribute("data-title") : "Feature";
                    return '<span class="' + className + '">' + title + '</span>';
                },
            },
            on: {
                init: function () {
                    // Force outer swiper to recalculate height once initialized
                    setTimeout(() => {
                        if (mainContentSwiper) {
                            mainContentSwiper.updateAutoHeight();
                        }
                    }, 100);
                },
                slideChangeTransitionEnd: function () {
                    if (mainContentSwiper) {
                        mainContentSwiper.updateAutoHeight();
                    }
                }
            }
        });
    });
};

document.addEventListener("DOMContentLoaded", () => {
    initFeatureEverythingNeed();
});